/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmployeeModel } from '../../models/employee-model';

export interface GetClientRep$Plain$Params {

/**
 * id of clientrep for filter
 */
  clientRepId: number;
}

export function getClientRep$Plain(http: HttpClient, rootUrl: string, params: GetClientRep$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<EmployeeModel>> {
  const rb = new RequestBuilder(rootUrl, getClientRep$Plain.PATH, 'get');
  if (params) {
    rb.path('clientRepId', params.clientRepId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmployeeModel>;
    })
  );
}

getClientRep$Plain.PATH = '/api/ClientRep/{clientRepId}';
